export default {
  'pages.security.title1': 'Login phone modify',
  'pages.security.title2': 'Login password modify',
  'pages.security.phone': 'Phone number',
  'pages.security.modify': 'modify',
  'pages.security.form.code': 'Verification code',
  'pages.security.form.code.placeholder': 'Please enter your verification code',
  'pages.security.form.sendCode': 'Send code',
  'pages.security.form.hasSend': ' ',
  'pages.security.form.newPassword': 'New password',
  'pages.security.form.newPassword.placeholder':
    '8-20 digits, must contain a numbers and letters',
  'pages.security.form.newPassword1': 'Repeat password',
  'pages.security.form.newPassword1.error':
    'The two entered passwords do not match',
  'pages.security.form.newPassword1.placeholder': 'Please enter password again',
  'pages.security.form.modifyBtn': 'Modify',
  'pages.security.form.sendCode.fail':
    'Failed to send verification code, please resend',
  'pages.security.form.submit.success': 'Modified success, please login again',
  'pages.security.form.submit.fail': 'Modified fail, please try again',

  'pages.security.modal.title': 'Login phone modify',
  'pages.security.modal.oldPhone': 'Old phone number',
  'pages.security.modal.next': 'Next',

  'pages.security.modal.newPhone': 'New phone number',
  'pages.security.modal.newPhone.placeholder': 'Please enter new phone number',
  'pages.security.modal.newPhone.valid': 'please enter a valid phone number',
  'pages.security.modal.submit.success': 'Modified success',
};
